import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { actionCreators } from "../redux/discountsSagas";

const StaffFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.discounts.filters.staffs);
  const selectedFilters = useSelector((state) => state.discounts.selectedFilters.staffs);
  const filtersLoading = useSelector((state) => state.discounts.filtersLoading);

  return (
    <div className="select-box-no-width">
      <p>Staff</p>
      {filtersLoading ? (
        <button className="picky__input">
          <LoadingAnimation uiLoader />
        </button>
      ) : (
        <MultiSelectDropdown
          options={options}
          selectedFilters={selectedFilters}
          placeholder="Not selected"
          numberDisplayed={0}
          includeSelectAll
          enableOnly
          onSelectChange={(data) => dispatch(actionCreators.updateFilter({ key: "staffs", data }))}
        />
      )}
    </div>
  );
};

export default StaffFilter;
